import { createMarketplaceEventFactory } from '../index';
export const getMarketplaceProviderInteractionEvent = createMarketplaceEventFactory('Marketplace Provider', 'Marketplace Provider Interaction');